import styled from 'styled-components/native'

import { ButtonWithText } from '../App/Components'
import StyleVariables from '../StyleVariables'

export const StyledImage = styled.Image`
  padding: 0 1.5em;
  margin: 1.5em auto 0 auto;
  max-width: ${StyleVariables.cardMaxWidth};
  width: 75%;
  height: 100px;
  align-self: center;
`

export const StyledContainer = styled.View<{
  highlightcolor: string
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px 0;
  background-color: ${({ highlightcolor }) => highlightcolor + 15};
`

export const PersonBlock = styled.View<{ highlightcolor: string }>`
  border: 1px solid ${({ highlightcolor }) => highlightcolor};
  border-radius: ${StyleVariables.borderRadiusCard};
  padding: ${StyleVariables.cardPadding};
  margin: ${StyleVariables.cardMargin};
  max-width: ${StyleVariables.cardMaxWidth};
  align-self: center;
`

export const PersonBlockContent = styled.View`
  display: flex;
  flex-direction: column;
`

export const AddPersonButton = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px ${StyleVariables.horizontalGutter};
  border: 1px solid ${StyleVariables.colorBlack};
  border-radius: ${StyleVariables.borderRadiusPill};
  margin: 0 auto 16px;
  align-self: center;
`

export const AddPersonButtonText = styled.Text`
  font-size: ${StyleVariables.fontSizeBase};
  color: ${StyleVariables.colorBlack};
  margin-left: 10px;
`

export const ConfirmBlock = styled.View<{ highlightcolor: string }>`
  position: relative;
  border: 1px solid ${({ highlightcolor }) => highlightcolor};
  border-radius: ${StyleVariables.borderRadiusCard};
  padding: ${StyleVariables.cardPadding};
  margin: ${StyleVariables.cardMargin};
  width: calc(100% - 40px);
  align-self: center;
`

export const ConfirmBlockEditIcon = styled.View`
  position: absolute;
  top: 12px;
  right: 12px;
`

export const ConfirmBlockHeader = styled.Text<{ fontcolor: string }>`
  font-weight: bold;
  font-size: ${StyleVariables.fontSizeBase};
  text-align: center;
  margin-bottom: 16px;
  color: ${({ fontcolor }) => fontcolor};
`

export const ConfirmBlockContent = styled.View`
  display: flex;
  flex-direction: column;
`

export const ConfirmServiceRow = styled.View`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 10px;
`

export const ConfirmServiceText = styled.Text<{ fontcolor: string }>`
  color: ${({ fontcolor }) => fontcolor};
  font-size: ${StyleVariables.fontSizeBase};
  flex: 1;
  margin-left: 13px;
  margin-top: auto;
  display: flex;
  justify-content: space-between;
`

export const ConfirmDetailText = styled.Text<{ fontcolor: string }>`
  color: ${({ fontcolor }) => fontcolor};
  font-size: ${StyleVariables.fontSizeBase};
  margin-bottom: 10px;  
  display: flex;
  justify-content: space-between;
`

export const ServiceTitle = styled.Text<{ fontcolor: string }>`
  text-align: center;
  padding: 0 1.5em;
  margin: 1.5em auto 1.5em;
  max-width: ${StyleVariables.cardMaxWidth};
  align-self: center;
  color: ${({ fontcolor }) => fontcolor};
  font-size: 22px;
  font-weight: 700;
`

export const AddActivityContainer = styled.View`
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`

export const ActivityItem = styled.Text`
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  align-items: baseline;
`

export const StyledButtonWithText = styled(ButtonWithText)`
  padding: 6px 60px;
`
